// Imports comuns do Vue
import Vue from 'ninenine-white-label/Vue';
import App from './App.vue';
import store from './store/store';
import router from './router';
import './registerServiceWorker';

// Imports de libs auxiliares
import 'vue-material-design-icons/styles.css';
// import {
//   Card,
//   Button,
//   Collapse,
//   Tabs,
//   Modal,
//   Nav,
// } from 'bootstrap-vue/es/components';
// import { Scrollspy, Tooltip } from 'bootstrap-vue/es/directives';

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';

import VueSweetalert2 from 'vue-sweetalert2';
import VueTheMask from 'vue-the-mask';
import browserDetect from 'vue-browser-detect-plugin';
import VueCroppie from 'vue-croppie';
import VueGtag from "vue-gtag";
import 'croppie/croppie.css';
import Selectize from 'vue2-selectize';
import moment from 'moment';
import VueMoment from 'vue-moment';
import VueFloatLabel from 'vue-float-label';
import VueIntercom from 'vue-intercom';
import 'bootstrap-vue/dist/bootstrap-vue.css';

moment.locale('pt-br');

// Vue.use(Card);
// Vue.use(Button);
// Vue.use(Collapse);
// Vue.use(Tabs);
// Vue.use(Modal);
// Vue.use(Nav);
// Vue.use(Scrollspy);
// Vue.use(Tooltip);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.use(VueSweetalert2);
Vue.use(VueTheMask);
Vue.use(VueGtag, {
  config: { id: "G-D052MSGKPD" },
  includes: [
    { id: 'GTM-W8DJTQ3' },
    { id: 'G-P6LCYDFPYC' }, // ninenine-ga
  ]
}, router);
Vue.use(browserDetect);
Vue.use(VueCroppie);
Vue.component('selectize', Selectize);
Vue.use(VueMoment, {
  moment
});
Vue.use(VueFloatLabel);
Vue.use(VueIntercom, { appId: 'nq6fayk7' });

// Imports do projeto base
import TnsSlider from 'ninenine-white-label/plugins/TnsSlider';
import GLightbox from 'ninenine-white-label/plugins/GLightbox';
import SocialAuth from 'ninenine-white-label/plugins/SocialAuth';

Vue.use(TnsSlider);
Vue.use(GLightbox);

Vue.prototype.socialIds = {
  facebook:
    process.env.NODE_ENV == 'development'
      ? '236232058720466'
      : '236232058720466',
  linkedin:
    process.env.NODE_ENV == 'development' ? '77u469kmitkjiy' : '77u469kmitkjiy',
};

Vue.use(SocialAuth, {
  facebook: Vue.prototype.socialIds.facebook,
});

// Funcao auxiliar
Vue.prototype.delay = function (time) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, time);
  });
};

Vue.prototype.removeAutoFillSelectize = function () {
  Array.from(document.querySelectorAll('input')).map((element) => {
    element.setAttribute('autocomplete', 'no');
  });
};

Vue.prototype.goToInvalidField = function (context) {
  setTimeout(() => {
    const element = context || document;
    Array.from(element.querySelectorAll('.is-invalid')).some((field) => {
      field.querySelector('input, textarea').focus();
      return field;
    });
  }, 400);
};

Vue.prototype.dateRange = function (dateFrom, dateTo) {
  let a = Vue.prototype.$moment(dateTo);
  let b = Vue.prototype.$moment(dateFrom);
  let message = '';

  let years = a.diff(b, 'year');
  b.add(years, 'years');

  let months = a.diff(b, 'months');
  b.add(months, 'months');

  if (years > 0) message += years + ' anos ';
  if (months > 0) message += months + ' meses ';

  return message;
};

Vue.config.productionTip = false;
Vue.prototype.$EventBus = new Vue();

Vue.prototype.$grid = () => {
  const grid = {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200
  }

  let currence = window.innerWidth;

  if (currence >= grid.xl) return 'xl';
  if (currence >= grid.lg) return 'lg';
  if (currence >= grid.md) return 'md';
  if (currence >= grid.sm) return 'sm';
  if (currence <= grid.sm) return 'xs';

}

new Vue({
  router,
  store,
  render: (h) => h(App),
  mounted() {
    if (!this.$store.state.user.isAuth) {
      this.$intercom.boot({
        name: 'Candidate',
        custom_domain: this.$store.state.source,
      });
    } else {
      const user_hash = this.$CryptoJS.HmacSHA256(this.$store.state.user.profile.email, "a8Lf6zmvjJCDmBu5kEtJ57D5Ju8GiMegw7NQpxcp").toString();

      this.$intercom.boot({
        user_hash,
        name: this.$store.state.user.profile.name,
        email: this.$store.state.user.profile.email,
        custom_domain: this.$store.state.source,
      });
    }
  },
}).$mount('#app');
